const dataDisplayOptions = [
  { value: '0', label: 'Flu Index', exp: 'forecast_value' },
]

export default dataDisplayOptions
